import type { CSSProperties, ReactElement } from "react";

import styles from "./LoaderStyles.module.css";

const Loader = (): ReactElement => {

  const loaderStyle: CSSProperties = {
    border: "7px solid var(--global-web-app-loader-border)",
    borderBottomColor: "var(--global-web-app-loader-border-bottom)",
  };

  return (
    <div className={styles.container}>
      <div className={styles.loader} style={loaderStyle} />
    </div>
  );
};

export default Loader;
